import moment from 'moment'

export const defaultLessonForm = {
	name: '',
	date: moment().format('YYYY-MM-DD'),
	group: null,
}

export const defaultFilter = {
	sort_field: '',
	sort_order: '',
}
